import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrl: './photos.component.css',
  standalone: false
})

export class PhotosComponent implements OnChanges {
  // Inject the service and expose the signal to the template
  SelectedFolder = inject(DataService).filenames;


  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['SelectedFolder']) {
      // Handle the change
      console.log('PhotosComponent SelectedFolder changed:', this.SelectedFolder);
      // You can add additional logic here to respond to the change
      this.SelectedFolder = changes['SelectedFolder'].currentValue;
    }
  }

  goBack() {
    window.history.back();
  }

}


